
function Anji2({ className }) {
    return (
        <div className={className}>
            <img src='/imgs/_icons/anji2.svg' alt=""/>
        </div>
    )
}

export default Anji2